import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

function list(params) {
  return request({
    url: ENDPOINT.ORGANIZATIONS,
    method: "get",
    params,
  });
}

async function fetchById(id) {
  return await request({
    url: `${ENDPOINT.ORGANIZATIONS}/${id}`,
    method: "get",
  });
}

function create(data) {
  return request({
    url: ENDPOINT.ORGANIZATIONS,
    method: "post",
    data,
  });
}

function update(data) {
  return request({
    url: `${ENDPOINT.ORGANIZATIONS}/${data.id}`,
    method: "patch",
    data,
  });
}

function remove(data) {
  return request({
    url: `${ENDPOINT.ORGANIZATIONS}/${data.id}`,
    method: "delete",
    data,
  });
}

export default {
  list,
  fetchById,
  create,
  update,
  remove,
};
